module.exports = __webpack_public_path__ + "static/media/70Pie.e7b33101.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/70Pie.png
// module id = 1686
// module chunks = 0 1